// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"135":"doatahlil","177":"home","314":"setting","401":"yasin","443":"about","609":"team","631":"contact","910":"tahlil"}[chunkId] + "." + {"135":"56bd4d0e","177":"e9a670f5","314":"674edd4f","401":"1dd3c22c","443":"2dff3e61","609":"089b52d4","631":"f0d565f7","910":"348a7204"}[chunkId] + ".js";
};